import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../../config';

/* I civici FTTH che TIM consegna ogni tanto.

   È l'acceleratore: dove il civico coincide ESATTAMENTE con quello di un nostro cliente,
   quel cliente risulta coperto senza aspettare il giro dell'agente. Il civico deve essere
   identico — la fibra è posata civico per civico, può esserci al 3/A e non al 3/B.

   Prima si fa la prova, che non scrive niente; poi si applica. */

const nf = (n) => (n || 0).toLocaleString('it-IT');

export default function CiviciFtthCard() {
  const [stato, setStato] = useState(null);
  const [job, setJob] = useState(null);
  const [esito, setEsito] = useState(null);
  const [files, setFiles] = useState([]);
  const poll = useRef(null);
  const input = useRef(null);

  const carica = useCallback(() => {
    axios.get(`${API}/copertura/civici-ftth`).then((r) => setStato(r.data)).catch(() => setStato(null));
  }, []);
  useEffect(() => { carica(); return () => clearInterval(poll.current); }, [carica]);

  const avvia = async (applica) => {
    if (!files.length) return;
    setEsito(null);
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    fd.append('applica', applica ? 'true' : 'false');
    try {
      const r = await axios.post(`${API}/copertura/civici-ftth`, fd);
      setJob({ id: r.data.id, stato: 'in_corso' });
      clearInterval(poll.current);
      poll.current = setInterval(async () => {
        try {
          const s = await axios.get(`${API}/copertura/civici-ftth/${r.data.id}`);
          setJob(s.data);
          if (s.data.stato === 'completato' || s.data.stato === 'errore') {
            clearInterval(poll.current);
            setJob(null);
            if (s.data.stato === 'errore') toast.error(s.data.errore || 'Import non riuscito');
            else { setEsito(s.data.esito); carica(); if (applica) toast.success('Civici importati'); }
          }
        } catch { /* ritenta */ }
      }, 1500);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore caricamento');
    }
  };

  const inCorso = !!job;
  return (
    <div className="cop-card">
      <div className="cop-card-h">Civici FTTH consegnati da TIM</div>

      {stato && stato.totale > 0 ? (
        <div style={{ display: 'flex', gap: 26, flexWrap: 'wrap', marginBottom: 12 }}>
          <div><div className="cop-kpi-v">{nf(stato.totale)}</div><div className="cop-kpi-l">Civici in archivio</div></div>
          <div><div className="cop-kpi-v">{nf(stato.comuni)}</div><div className="cop-kpi-l">Comuni</div></div>
          <div><div className="cop-kpi-v" style={{ color: '#14746f' }}>{nf(stato.clienti_marcati)}</div>
            <div className="cop-kpi-l">Clienti coperti dai file</div>
            <div className="cop-kpi-s">senza nessuna verifica</div></div>
        </div>
      ) : (
        <p className="cop-note" style={{ margin: '0 0 12px' }}>
          Nessun elenco caricato. Quando TIM consegna i «Civici Aperti FTTH», caricali qui.
        </p>
      )}

      {stato?.consegne?.length > 0 && (
        <div style={{ marginBottom: 14 }}>
          <div className="cop-note" style={{ marginBottom: 4 }}>Consegne in archivio:</div>
          {stato.consegne.map((c) => (
            <div key={c.consegna} style={{ fontSize: 12.5, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <b>{c.consegna}</b>
              <span className="cop-note">{nf(c.civici)} civici</span>
              <span className="cop-note">{c.aggiornato_at ? `caricata il ${new Date(c.aggiornato_at).toLocaleDateString('it-IT')}` : ''}</span>
            </div>
          ))}
        </div>
      )}

      <input ref={input} type="file" multiple accept=".csv,.xlsx" style={{ display: 'none' }}
        onChange={(e) => { setFiles([...e.target.files]); setEsito(null); e.target.value = ''; }} />
      <div className="cop-strip">
        <button className="btn btn-secondary" onClick={() => input.current?.click()} disabled={inCorso}>
          Scegli i file (CSV o Excel)
        </button>
        {files.length > 0 && <span className="cop-note">{files.length} file: {files.map((f) => f.name).join(', ').slice(0, 90)}</span>}
      </div>

      {files.length > 0 && (
        <div className="cop-strip" style={{ marginTop: 10 }}>
          <button className="btn" onClick={() => avvia(false)} disabled={inCorso}>
            {inCorso ? 'Analisi in corso…' : 'Prova senza scrivere'}
          </button>
          <button className="btn btn-primary" onClick={() => avvia(true)} disabled={inCorso || !esito}>
            Applica
          </button>
          {!esito && <span className="cop-note">Prima la prova: «Applica» si sblocca dopo.</span>}
        </div>
      )}

      {inCorso && <div className="cop-note" style={{ marginTop: 10 }}>{job.fase === 'confronto' ? 'Confronto con l\'archivio clienti…' : 'Lettura dei file…'}</div>}

      {esito && (
        <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid var(--border-card, #e2e8f0)' }}>
          {esito.civici === 0 ? (
            <div className="cop-note">{esito.motivo || 'Nessun civico riconosciuto nel file.'}</div>
          ) : (
            <>
              <div style={{ fontSize: 13.5, lineHeight: 1.8 }}>
                <b>{nf(esito.civici)}</b> civici letti{esito.fibercop != null && <> · <b>{nf(esito.fibercop)}</b> vendibili FiberCop</>}.<br />
                Clienti col civico identico: <b>{nf(esito.aggiornati + esito.gia_ftth)}</b>, di cui <b>{nf(esito.gia_ftth)}</b> già noti come FTTH.<br />
                {esito.applicato ? 'Aggiornati' : 'Da aggiornare'}: <b style={{ color: '#14746f' }}>{nf(esito.aggiornati)}</b>
                {esito.non_tim > 0 && <> · <b style={{ color: '#e0662e' }}>{nf(esito.non_tim)} NON TIM</b>, i lead veri</>}.<br />
                Sulla stessa via ma altro civico: <b>{nf(esito.stessa_via)}</b>
                {esito.vicini_entro_10 > 0 && <>, di cui <b>{nf(esito.vicini_entro_10)}</b> entro dieci numeri</>}.<br />
                <span className="cop-note">
                  Non vengono segnati come coperti — la fibra è posata civico per civico —
                  ma {esito.applicato ? 'sono stati contrassegnati' : 'verranno contrassegnati'} «vicino
                  a FTTH nuova»: l'agente li rimette in lavorazione <b>subito</b>, fuori dal timing e
                  in testa alla coda, partendo dal civico più vicino a quello aperto.
                </span>
              </div>
              {esito.saltati?.length > 0 && (
                <div className="cop-note" style={{ marginTop: 6 }}>Saltati (non sono elenchi di civici): {esito.saltati.join(', ')}</div>
              )}
              {esito.elenco?.length > 0 && (
                <div className="cop-tablewrap" style={{ marginTop: 10, maxHeight: 260 }}>
                  <table className="cop-table">
                    <thead><tr><th className="l">Azienda</th><th className="l">Comune</th><th className="l">Indirizzo</th><th className="l">Prima</th><th className="l">456</th></tr></thead>
                    <tbody>
                      {esito.elenco.map((r, i) => (
                        <tr key={i}>
                          <td className="l">{r.ragione_sociale || '—'}</td>
                          <td className="l">{r.comune}</td>
                          <td className="l">{r.indirizzo}</td>
                          <td className="l">{r.da || 'mai verificato'}</td>
                          <td className="l">{r.risultato || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {!esito.applicato && esito.aggiornati > 0 && (
                <div className="cop-note" style={{ marginTop: 8 }}>
                  Niente è stato scritto. Premi «Applica» per segnare questi clienti come FTTH.
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
